// extracted by mini-css-extract-plugin
export default {"section":"components-ProductSection-productSection__section--GjQV5","gridStyling":"components-ProductSection-productSection__gridStyling--aeV6z"};